// import $ from "jquery";

document.addEventListener("DOMContentLoaded", e => {

	const inputs = document.querySelectorAll(".default-input__input--file");
	
	for (const input of inputs){
		
	
		input.addEventListener("change", function() {
			let files = [];
			
			const textInput = this.closest(".comments-area, .article-text, .default-input")
								.querySelector(".default-input__input[type='text']");
	
			console.log(textInput)
			for (let i = 0; i < input.files.length; i++)
				files.push(input.files[i].name)
			if (!files.length){
				textInput.value = "";

			} else{
				textInput.value = files.join(",     ");
				textInput.removeAttribute('hidden')

			}
		})

		
	}

	if(document.querySelector('.default-input__input-clear')){

		document.querySelector('.default-input__input-clear').addEventListener('click', function() {
			console.log(this);
	
			let prevEl = this.previousElementSibling;
			
			prevEl.setAttribute('hidden', 'hidden');
			prevEl.value = "";
	
		})
	}


	
})






// WEBPACK FOOTER //
// ./src/js/comment-files.js